/* jshint node:true */
'use strict';

var createStore = require('fluxible/addons').createStore;
var PersistentStateMixin    = require('../mixins/PersistentStateMixin');

var storeLeagues = createStore({

    storeName: 'LeagueStore',

    mixins: [PersistentStateMixin],

    initialize: function() {
        this.data = {
            leagues:[],
            sport:null,
            league:null,
            params:null,
            allLeaguesOption:{
                "id": "1",
                "name": "All Leagues",
                "abbreviation": "All Leagues",
                "midsizeName": "1"
            }
        };
    },

    handlers: {
        RECEIVED_LEAGUES: function(payload) {
            
            var leagues = (payload && payload.data && payload.data.leagues || []).unshift(this.data.allLeaguesOption);
            this.data.leagues     = payload.data.leagues || [];
            this.data.sport       = payload.sport;
            this.data.league      = payload.league;
            this.data.params      = payload.params;

            this.emitChange();
        }
    },

    getLeagues: function(sSport) {
        try {
            return this.data || {};
        } catch (e) {
            return {};
        }
    },

});

module.exports = storeLeagues;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/stores/LeagueStore.js
 **/